//#region imports
import React, { useEffect, useState } from "react";

// styling
import { Spacing } from "_styles";
import "./job-card.css"
import { assistanceParagraph, breakTaskCounter, flightNumberParagraph, statusCircle } from "./job-styles";

// utils
import { getTaskCardStatus, getJobStatusColor } from "_utils/functions";
import TaskAccept from "./task-accept";
import { MdFreeBreakfast } from "react-icons/md";
import { useInterval } from "_utils/hooks";
//#endregion

const BreakTaskCard = (props) => {

    //#region local states
    const [time, setTime] = useState("");                                                                           // time of flight departure / arrival
    const [jobStatusLine, setJobStatusLine] = useState("Not Assigned");                                             // status of job
    const [breakTaskPeriod, setBreakTaskPeriod] = useState("")                      // holds value of the break task period
    const [downTimer, setDownTimer] = useState({
        taskId: props?.job?._id,
        timer: false,
        remainingTime: null,
    });
    //#endregion

    //#region useEffects

    // handle if job has not been assigned (job is still in timeline jobs list not on timeline)
    useEffect(() => {
        // check if assigned time is null, then we know booking has not been assigned
        if (props.job.assignedTime) {
            setTime(props.job.assignedTime)
        }
        setBreakTaskPeriod(props.job?.breakTaskInformation?.breakTaskPeriod)
    }, [props.job]);


    // set job states if it is a isBreakTask 
    useEffect(() => {
        if (props?.job?.isBreakTask) {
            const cardStatus = getTaskCardStatus(props?.job)
            setJobStatusLine(cardStatus?.status)

        }
    }, [props.job]);

    //#endregion

    //#region functions  

    //#region custom Hooks
    //This should calculate down time  for break task
    useInterval(async () => {
        const job = props.job
        if (
            !job ||
            job?.completed == true ||
            job?.cancelled == true ||
            job?.notPlanned == true ||
            job?.isBreakTask !== true ||
            job?.active !== true
        )
            return;

        const startTime = job.startTime;
        //get the task period, breakTaskPeriod will be like 15 Minutes or 1 hour
        const breakTaskPeriod = job.breakTaskInformation.breakTaskPeriod.includes("Minutes") ? job.breakTaskInformation.breakTaskPeriod.split(" ")[0] : 60;

        const startTimeInMillis = (startTime.seconds * 1000) + (startTime.nanoseconds / 1e6);
        // Create a Date object for the start time
        const startDate = new Date(startTimeInMillis);

        const endDate = new Date(startDate.getTime() + Number(breakTaskPeriod) * 60000); // 60000 ms = 1 minute
        const currentTime = new Date(); // Current time

        //Calculate the difference in milliseconds
        const timeRemaining = endDate.getTime() - currentTime.getTime();
        if (timeRemaining > 0) {
            const minutesRemaining = Math.floor(timeRemaining / 60000);

            setDownTimer((prev) => ({
                ...prev,
                taskId: job?._id,
                timer: true,
                remainingTime: minutesRemaining,
            }));
        } else {
            setDownTimer((prev) => ({
                ...prev,
                taskId: job?._id,
                timer: false,
                remainingTime: 0,
            }));
        }
    }, 60000);

    //#endregion

    return (
        <>
            {/* job card */}
            <div onDoubleClick={(e) => { props.handleLeftClick(e) }} onClick={(e) => { props.handleJobClick(e) }} style={{ display: "flex", justifyContent: "center" }}>
                <div onContextMenu={(e) => { props.handleLeftClick(e) }} style={props.cardStyle}>

                    {/* top half of card */}
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "10px" }}>
                            <p style={flightNumberParagraph}>Break Task</p>
                            <MdFreeBreakfast
                                size={16}
                                color={"black"}
                                style={{ opacity: 0.6, marginLeft: Spacing.SCALE_4, marginRight: Spacing.SCALE_4 }}
                            />
                        </div>

                        <p style={{ margin: "0px", textAlign: "center", fontSize: 11 }}>{time}</p>

                    </div>

                    {/* horizontal line break */}
                    <hr style={{ margin: "0px" }} />

                    {/* bottom half of card */}
                    <div>
                        {/* status information */}
                        <div style={{ display: "flex", justifyContent: "space-between", position: "relative", alignItems: "baseline" }}>

                            {/* status color icon / check in icon */}

                            {downTimer?.taskId == props.job?._id &&
                                downTimer?.timer &&
                                props.job?.pending !== true &&
                                props.job?.isBreakTask &&
                                props.job?.cancelled != true &&
                                props.job?.notPlanned != true &&
                                props.job?.active === true && (

                                    <div style={breakTaskCounter}>
                                        <p style={{ color: "red", fontSize: 9, width: "100%", margin: 0 }}>{downTimer.remainingTime}M</p>
                                    </div>
                                )}
                            <p style={assistanceParagraph}>
                                {breakTaskPeriod}
                            </p>


                            <div style={{ display: "flex", position: "relative", alignItems: "center" }}>
                                {/* status icon */}
                                {
                                    props?.job?.paxPositionInfo?.activity == "Checked-in" || props?.job?.originalBookingDoc?.paxPositionInfo?.paxStatus == "checkedIn"
                                        ?
                                        <div style={{ backgroundColor: 'green', boxShadow: "0 0 15px green, 0 0 30px green, 0 0 45px green" }} class="glowing-circle"></div>
                                        :
                                        <div style={{ ...statusCircle, backgroundColor: getJobStatusColor(props?.job) }} />
                                }

                                {/* status text */}
                                <p style={{
                                    margin: "0px 0", textAlign: "center",
                                    fontSize: '11px',
                                    color: getJobStatusColor(props?.job),
                                    fontWeight: "700"
                                }}>{props?.job?.paxPositionInfo?.activity == "Checked-in" ? 'Checked-in' : jobStatusLine}</p>
                            </div>

                        </div>
                    </div>

                </div>
            </div>

            {/* task accept modal */}
            <TaskAccept task={props?.job} closeModal={props.closeModal} toggleAcceptModal={props.toggleAcceptModal} />
        </>
    );
};

export default BreakTaskCard;
